export default __webpack_public_path__ + "static/media/MarsCentra-Bold.a6b56a6d.woff";